import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TypeStructure } from 'src/app/shared/models/typeStructure';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TypeStructureModalAjoutComponent } from '../modal/typeStructure-modal-ajout/typeStructure-modal-ajout.component';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { TypeStructureModalDetailComponent } from '../modal/typeStructure-modal-detail/typeStructure-modal-detail.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-typeStructure',
	templateUrl: './list-typeStructure.component.html',
	styleUrls: ['./list-typeStructure.component.scss']
})
export class ListTypeStructureComponent implements OnInit {
	typeStructure: TypeStructure[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	typeStructureCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editTypeStructureModalRef: BsModalRef;
	addTypeStructureModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getTypeStructure();
		this.isAddable = true;
	}

	getTypeStructure(): void {
		this.isListingLoading = true;
		this.facade.typeStructureService.getAllTypeStructure().subscribe({
			next: (val) => {
				this.typeStructure = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.typeStructure.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.typeStructure = [];
			}
		});
	}

	selectTypeStructure(typeStructure: TypeStructure): void {
		const link = ['/typeStructure', typeStructure.id];
		this.router.navigate(link);
	}

	importTypeStructure(event: any): void {
		this.typeStructureCsvFile = event.target.files[0];

		this.facade.typeStructureService
			.importTypeStructure(this.typeStructureCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.alerts.push({
						type: 'success',
						msg: `${importStats.entitiesAdded} typeStructure ont été ajoutés,
                  ${importStats.entitiesBeforeImport} étaient déjà présents.`
					});

					this.getTypeStructure();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
					this.logger.error(
						'' + err.status + ' ' + err.error.message ? err.error.message : ''
					);
				}
			});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		this.addTypeStructureModalRef = this.modalService.show(
			TypeStructureModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addTypeStructureModalRef.onHide.subscribe((reason: string | any) => {
			this.getTypeStructure();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(typeStructure: TypeStructure) {
		const initialState = {
			typeStructure: typeStructure
		};
		this.editTypeStructureModalRef = this.modalService.show(
			TypeStructureModalDetailComponent,
			{
				class: '',
				initialState
			}
		);

		this.editTypeStructureModalRef.onHide.subscribe((reason: string | any) => {
			this.getTypeStructure();
		});
	}
}
